<template>
		<div class="revslider" data-alias="es-productos" id="es-servicios"></div> 
</template>

<script>
	export default {
		data: () => {
			return {     
				slider: ''
			}
		},
    created(){
    },
    beforeMount(){   	
    },
		mounted(){
      //console.log('mounted');
      jQuery(document).ready(Revslider.init);  

			/*jQuery('#es-servicios').show().revolution({
        
       });*/
			//console.log(this.getCurrentSliderAPI())
		},
    methods: {
      getCurrentSliderAPI() {
        var slider = jQuery('.rev_slider');
        //console.log(slider.length)
        if(!slider.length) return false; 
        return eval('revapi' + slider.attr('id').split('rev_slider_')[1].split('_')[0]);
      }
    },
    beforeDestroy(){
      //console.log('beforeDestroy')
      var revapi = this.getCurrentSliderAPI();
      //console.log(revapi)
      if(revapi) {
          // destroy current slider
          revapi.revkill();
          revapi = null;
          //console.log('destroyed')
      }
    }
	}
</script>
